import { ShowSuccessResponseResponse } from '../../openapi/model';

export const getNormalizedShowId = (show: ShowSuccessResponseResponse): number | undefined =>
    show?.id;
